import { CanvasDrawer } from "../CanvasDrawer";

export const templateBlob = async () => {
    const url = await CanvasDrawer.captureCanvas(null);
    if (!url) return null;

    const blob = await fetch(url).then(res => res.blob());
    return blob
};